module.exports = __webpack_public_path__ + "static/media/shanzelize Still 08.f602c4be.webp";